import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const productsPathMap = localizePathMap({
	[Locale.cs]: "nase-reseni/podle-typu-produktu",
	[Locale.en]: "our-solutions/by-product-type",
});
